module.exports = __webpack_public_path__ + "static/img/sugerence.55299606.png";